// extracted by mini-css-extract-plugin
module.exports = {"frame":"KnowledgeBaseUserManagement_frame__N8YFP","innerFrame":"KnowledgeBaseUserManagement_innerFrame__9IgLh","highlightfirst":"KnowledgeBaseUserManagement_highlightfirst__Cwg7m"};